import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

const GiveawaySlider = ({ giveaways }) => {
  const history = useHistory();

  const list = useMemo(() => (Array.isArray(giveaways) ? giveaways.filter(Boolean) : []), [giveaways]);

  const viewportRef = useRef(null);
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (list.length) {
      const el = viewportRef.current;
      if (!el) return;
      const onScroll = () => {
        const idx = Math.round(el.scrollLeft / el.clientWidth);
        setPage(Math.max(0, Math.min(idx, list.length - 1)));
      };
      el.addEventListener("scroll", onScroll, { passive: true });
      return () => el.removeEventListener("scroll", onScroll);
    }
  }, [list.length]);

  if (!list.length) return null;

  return (
    <div className="giveaway">
      <div className="giveaway-viewport" ref={viewportRef}>
        <div className="giveaway-track" style={{ width: `${list.length * 100}%` }}>
          {list.map((g, i) => (
            <div className="giveaway-slide" key={g.id || i}>
              <div
                className="giveaway-img"
                onClick={() => history.push(`/giveaway/${g.id}`)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && history.push(`/giveaway/${g.id}`)}
                style={{ backgroundImage: `url(${g.imageUrl})` }}
              >

                {list.length > 1 && (
                  <div className="giveaway-dots">
                    {list.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === page ? "active" : ""}`}
                        onClick={() => {
                          const el = viewportRef.current;
                          if (!el) return;
                          el.scrollTo({ left: i * el.clientWidth, behavior: "smooth" });
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GiveawaySlider;
